<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button useRelativePath="true" previousPageUrl="../../../"></glxy-page-nav-button>
    </glxy-page-nav>
    @if (assistant$ | async; as assistant) {
      <glxy-page-title>
        <span>{{ assistant | assistantName }} - {{ 'AI_ASSISTANT.TESTING.TESTING_SUFFIX' | translate }}</span>
        @if (businessName()) {
          <span class="business-name">({{ businessName() }})</span>
        }
      </glxy-page-title>
    }
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="default">
    @if (assistantKey) {
      <div class="row row-gutters">
        <div class="col col-xs-12">
          <mat-card>
            <mat-card-content>
              <ai-test-case-display
                [title]="
                  isVoiceAssistant()
                    ? ('AI_ASSISTANT.TESTING.TEST_TYPE.CHAT' | translate) +
                      ' ' +
                      ('AI_ASSISTANT.TESTING.TEST_CASES.TITLE' | translate)
                    : ('AI_ASSISTANT.TESTING.TEST_CASES.TITLE' | translate)
                "
                (runTests)="runChatTests($event)"
                (configureTestRun)="configureAllChatTests()"
                (uploadTestCases)="openUploadDialog(chatTestType)"
                (generateTestCases)="goToGenerateTestCases(chatTestType)"
                [assistantKey]="assistantKey"
                #chatTable
              ></ai-test-case-display>

              @if (isVoiceAssistant()) {
                <mat-divider></mat-divider>
                <ai-test-case-display
                  [title]="
                    ('AI_ASSISTANT.TESTING.TEST_TYPE.VOICE' | translate) +
                    ' ' +
                    ('AI_ASSISTANT.TESTING.TEST_CASES.TITLE' | translate)
                  "
                  (runTests)="runVoiceTests($event)"
                  (configureTestRun)="configureAllVoiceTests()"
                  (uploadTestCases)="openUploadDialog(voiceTestType)"
                  (generateTestCases)="goToGenerateTestCases(voiceTestType)"
                  [assistantKey]="assistantKey"
                  [testType]="voiceTestType"
                  #voiceTable
                ></ai-test-case-display>
              }
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    }

    @if (testRunLoading) {
      <div class="row row-gutters">
        <div class="col col-xs-12">
          <glxy-loading-spinner fullWidth="false" size="small"></glxy-loading-spinner>
        </div>
      </div>
    }

    @if (assistantKey) {
      <div class="row row-gutters">
        <div class="col col-xs-12">
          <ai-test-run-table
            [assistantKey]="assistantKey"
            [hasVoice]="isVoiceAssistant()"
            #testRunTable
          ></ai-test-run-table>
        </div>
      </div>
    }
  </glxy-page-wrapper>
</glxy-page>
